'use strict';

var wNumb = require('../../vendors/wnumb.js');

var rates = {
	apr: [],
	interest: []
};

var formatters = {
	integerPriceFormatter: wNumb({
		decimals: 0,
		mark: '.',
		prefix: '£',
		thousand: ','
	}),

	priceFormatter: wNumb({
		decimals: 2,
		mark: '.',
		prefix: '£',
		thousand: ','
	}),

	yearsFormatter: wNumb({
		decimals: 0,
		postfix: ' years'
	}),

	rateFormatter: wNumb({
		postfix: '%'
	})
};

module.exports = {
	init: function(aprRates, interestRates) {
		rates.apr = aprRates;
		rates.interest = interestRates;
	},

	calculate: function(amount, term, creditRating) {
		var loanAmount = parseInt(amount);
		var termYears = parseInt(term);

		if (loanAmount < 0) {
			loanAmount = 0;
		}

		var interestRate = rates.interest[creditRating];
		var apr = rates.apr[creditRating];
		var costOfCredit = (apr / 200) * loanAmount * termYears;
		var totalRepayable = costOfCredit + loanAmount;
		var monthlyRepayment = totalRepayable / (termYears * 12);

		var result = {
			apr: formatters.rateFormatter.to(apr),
			creditCost: formatters.priceFormatter.to(costOfCredit),
			interestRate: formatters.rateFormatter.to(interestRate),
			loanAmount: formatters.integerPriceFormatter.to(loanAmount),
			monthlyRepayment: formatters.priceFormatter.to(monthlyRepayment),
			term: formatters.yearsFormatter.to(termYears),
			totalPayable: formatters.priceFormatter.to(totalRepayable),
		};

		return result;
	}
};
